import React from 'react';
import { Block } from '@mui/icons-material';
import environment1 from "../img/environment/environment1.png";
import environment2 from "../img/environment/environment2.png";

const Environment = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Environment and setting issues to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-3-vertical" style={{gridTemplateColumns: 'repeat(2, 1fr)'}}>
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={environment1} alt="Environment issue example 1" onClick={() => onImageClick && onImageClick(environment1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                The door has a problem
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={environment2} alt="Environment issue example 2" onClick={() => onImageClick && onImageClick(environment2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Wrong mirror reflect
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default Environment;